module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/keepCool.fr_CA-f6a250f16ff52e54c8b1d928024df0b1.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/keepCool.fr_CA.png
// module id = 2448
// module chunks = 2